module.exports = {
  title: 'Tokyu Vacations'
}
